module.exports = __webpack_public_path__ + "img/pigOutline.b8161511.jpg";